var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// js/sections/announcement-bar.js
import { timeline } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
import { EffectCarousel } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var AnnouncementBar = class extends EffectCarousel {
  _transitionTo(fromSlide, toSlide) {
    timeline([
      [fromSlide, { transform: ["translateY(0)", "translateY(-5px)"], opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }],
      [toSlide, { transform: ["translateY(5px)", "translateY(0)"], opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.2 }]
    ]);
  }
};
if (!window.customElements.get("announcement-bar")) {
  window.customElements.define("announcement-bar", AnnouncementBar);
}

// js/sections/before-after-image.js
var SplitCursor = class extends HTMLElement {
  connectedCallback() {
    this._parentSection = this.closest(".shopify-section");
    this._dragging = false;
    this._offsetX = this._currentX = 0;
    this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this));
    this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this));
    this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this));
    this._recalculateOffset();
    window.addEventListener("resize", this._recalculateOffset.bind(this));
  }
  get minOffset() {
    return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
  }
  get maxOffset() {
    return this.offsetParent.clientWidth + this.minOffset;
  }
  _onPointerDown(event) {
    if (event.target === this || this.contains(event.target)) {
      this._initialX = event.clientX - this._offsetX;
      this._dragging = true;
    }
  }
  _onPointerMove(event) {
    if (!this._dragging) {
      return;
    }
    this._currentX = Math.min(Math.max(event.clientX - this._initialX, this.minOffset), this.maxOffset);
    this._offsetX = this._currentX;
    this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
  }
  _onPointerUp() {
    this._dragging = false;
  }
  _recalculateOffset() {
    this._parentSection.style.setProperty("--clip-path-offset", `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`);
  }
};
if (!window.customElements.get("split-cursor")) {
  window.customElements.define("split-cursor", SplitCursor);
}

// js/sections/collection-list.js
import { timeline as timeline2, inView } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
var CollectionList = class extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView(this, this._reveal.bind(this), { margin: "-100px" });
    }
  }
  _reveal() {
    const toReveal = Array.from(this.querySelectorAll("[reveal-js]"));
    timeline2([
      [toReveal, { opacity: 1 }, { duration: 0 }],
      [toReveal.map((item) => item.querySelector("img, svg")), { opacity: [0, 1], transform: ["scale(1.03)", "auto"] }, { duration: 0.2 }],
      [toReveal.map((item) => item.querySelector(".collection-card__content-wrapper")), { opacity: [0, 1] }, { duration: 0.2 }]
    ]);
  }
};
if (!window.customElements.get("collection-list")) {
  window.customElements.define("collection-list", CollectionList);
}

// js/sections/customer-login.js
import { Delegate } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
var AccountLogin = class extends HTMLElement {
  connectedCallback() {
    this.recoverForm = this.querySelector("#recover");
    this.loginForm = this.querySelector("#login");
    if (window.location.hash === "#recover") {
      this._switchForms();
    }
    new Delegate(this).on("click", '[href="#recover"], [href="#login"]', this._switchForms.bind(this));
  }
  _switchForms(event) {
    if (event) {
      event.preventDefault();
    }
    this.recoverForm.hidden = !this.recoverForm.hidden;
    this.loginForm.hidden = !this.loginForm.hidden;
  }
};
if (!window.customElements.get("account-login")) {
  window.customElements.define("account-login", AccountLogin);
}

// js/sections/header.js
import { animate, timeline as timeline3, stagger, Delegate as Delegate2 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
import { AnimatedDetails, EffectCarousel as EffectCarousel2, Drawer, throttle } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var reduceMenuAnimation = JSON.parse("false");
var StoreHeader = class extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute("hide-on-scroll") && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._lastScrollTop = 0;
      this._accumulatedScroll = 0;
      this._isVisible = true;
      this._hasSwitchedToSticky = false;
      window.addEventListener("scroll", throttle(this._onScroll.bind(this)));
    }
    this.addEventListener("toggle", this._checkTransparency.bind(this), { capture: true });
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        this.classList.remove("is-filled");
        this._setupTransparentHeader();
      }
    });
    this._setupTransparentHeader();
    if (this.hasAttribute("sticky")) {
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:unload", this._setupTransparentHeader.bind(this));
        document.addEventListener("shopify:section:reorder", this._setupTransparentHeader.bind(this));
      }
    }
  }
  hide() {
    if (this._isVisible) {
      animate(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.2, easing: "ease" });
      this._isVisible = false;
    }
  }
  show() {
    if (!this._isVisible) {
      animate(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.2, easing: "ease" });
      this._accumulatedScroll = 0;
      this._isVisible = true;
    }
  }
  _onScroll() {
    if (window.scrollY < 0) {
      return;
    }
    this._accumulatedScroll = Math.max(0, this._accumulatedScroll + (window.scrollY - this._lastScrollTop));
    if (window.scrollY < this._lastScrollTop) {
      this.show();
    } else if (this._accumulatedScroll > parseInt(this.getAttribute("hide-on-scroll"))) {
      this.hide();
    }
    this._lastScrollTop = window.scrollY;
  }
  _checkTransparency() {
    let hasFallbackScrollDetection = false;
    if (CSS.supports("selector(:has(> *))") && this.hasAttribute("sticky") && !this.hasAttribute("hide-on-scroll") && this.hasAttribute("allow-transparency")) {
      const offsetBeforeChanging = 500;
      if (this.querySelectorAll("[open]").length > 0) {
        this.classList.add("is-filled");
      } else if (window.scrollY >= offsetBeforeChanging && !this._hasSwitchedToSticky) {
        this._hasSwitchedToSticky = true;
        this.classList.add("is-filled");
        animate(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.15, easing: "ease" });
      } else if (window.scrollY < offsetBeforeChanging) {
        if (this._hasSwitchedToSticky) {
          this._hasSwitchedToSticky = false;
          animate(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.15, easing: "ease" }).finished.then(() => {
            this.style.transform = null;
            this.classList.remove("is-filled");
          });
        } else if (this.getAnimations().length === 0) {
          this.classList.remove("is-filled");
        }
      }
    } else {
      hasFallbackScrollDetection = window.scrollY > 20;
      this.classList.toggle("is-filled", !this.hasAttribute("allow-transparency") || this.querySelectorAll("[open]").length > 0 || hasFallbackScrollDetection);
    }
  }
  _setupTransparentHeader() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
      this.setAttribute("allow-transparency", "");
      this.addEventListener("mouseenter", this._checkTransparency.bind(this));
      this.addEventListener("mouseleave", this._checkTransparency.bind(this));
      if (this.hasAttribute("sticky")) {
        window.addEventListener("scroll", throttle(this._checkTransparency.bind(this)));
      }
      this._checkTransparency();
    } else {
      this.removeAttribute("allow-transparency");
    }
  }
};
var DropdownDisclosure = class _DropdownDisclosure extends AnimatedDetails {
  constructor() {
    super();
    this._detectClickOutsideListener = this._detectClickOutside.bind(this);
    this._detectEscKeyboardListener = this._detectEscKeyboard.bind(this);
    this._detectFocusOutListener = this._detectFocusOut.bind(this);
    this._detectHoverListener = this._detectHover.bind(this);
    this._hoverTimer = null;
    this.addEventListener("mouseover", this._detectHoverListener.bind(this));
    this.addEventListener("mouseout", this._detectHoverListener.bind(this));
  }
  get trigger() {
    return !window.matchMedia("screen and (pointer: fine)").matches ? "click" : this.getAttribute("trigger");
  }
  get mouseOverDelayTolerance() {
    return 200;
  }
  /**
   * When the summary is clicked and that the mode is hover, we follow the link (if set) that may have been specified
   * on the parent. If the mode is click, then we deferred to the default behavior of the "AnimatedDetails" parent
   */
  _onSummaryClicked(event) {
    if (this.trigger === "hover") {
      event.preventDefault();
      if (event.currentTarget.hasAttribute("data-url")) {
        window.location.href = event.currentTarget.getAttribute("data-url");
      }
    } else {
      super._onSummaryClicked(event);
    }
  }
  async _transition(value) {
    if (value) {
      this.setAttribute("open", "");
      document.addEventListener("click", this._detectClickOutsideListener);
      document.addEventListener("keydown", this._detectEscKeyboardListener);
      document.addEventListener("focusout", this._detectFocusOutListener);
      const openSiblings = Array.from(this.closest("ul").querySelectorAll("[open]")).filter((item) => item !== this);
      openSiblings.forEach((sibling) => sibling.open = false);
      this.contentElement.style.opacity = "1";
      // await this._transitionIn(openSiblings.length > 0);
    } else {
      document.removeEventListener("click", this._detectClickOutsideListener);
      document.removeEventListener("keydown", this._detectEscKeyboardListener);
      document.removeEventListener("focusout", this._detectFocusOutListener);
      // await this._transitionOut();
      this.contentElement.style.opacity = "0";
      this.removeAttribute("open");
    }
  }
  _transitionIn(hasOpenSiblings = false) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }]];
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      timelineSequence.push([this.contentElement.querySelectorAll(":scope > ul > li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { delay: stagger(0.025), at: "-0.1", duration: 0.2 }]);
    }
    return timeline3(timelineSequence, { delay: hasOpenSiblings > 0 ? 0.1 : 0 }).finished;
  }
  _transitionOut() {
    return timeline3([[this.contentElement, { opacity: 0 }, { duration: 0.2 }]]).finished;
  }
  /**
   * When dropdown menu is configured to open on click, we add a listener to detect click outside and automatically
   * close the navigation.
   */
  _detectClickOutside(event) {
    if (this.trigger !== "click") {
      return;
    }
    if (!this.contains(event.target) && !(event.target.closest("details") instanceof _DropdownDisclosure)) {
      this.open = false;
    }
  }
  /**
   * On desktop device, if the mode is set to hover, we open/close the dropdown on hover
   */
  _detectHover(event) {
    if (this.trigger !== "hover") {
      return;
    }
    if (event.type === "mouseover") {
      if (this._hoverTimer) {
        clearTimeout(this._hoverTimer);
        this._hoverTimer = null;
      } else {
        this.open = true;
      }
    } 
    if (event.type === "mouseout") {
      this._hoverTimer = setTimeout(() => {
        this.open = false
        this._hoverTimer = null;
      }, this.mouseOverDelayTolerance);
    }
  }
  /**
   * Detect if we hit the "Escape" key to automatically close the dropdown
   */
  _detectEscKeyboard(event) {
    if (event.code === "Escape") {
      const targetMenu = event.target.closest("details[open]");
      if (targetMenu) {
        targetMenu.open = false;
      }
    }
  }
  /**
   * Close the dropdown automatically when the dropdown is focused out
   */
  _detectFocusOut(event) {
    if (event.relatedTarget && !this.contains(event.relatedTarget)) {
      this.open = false;
    }
  }
};
var MegaMenuDisclosure = class extends DropdownDisclosure {
  constructor() {
    super();
    this.addEventListener("pointerover", this._preloadImages.bind(this));
  }
  get mouseOverDelayTolerance() {
    return 500;
  }
  _transitionIn(hasOpenSiblings) {
    const timelineSequence = [[this.contentElement, { opacity: 1 }, { duration: 0.2 }], "mega-menu"], contentDelay = hasOpenSiblings ? 0.1 : 0;
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      this.contentElement.querySelectorAll(".mega-menu__promo").forEach((promo) => {
        timelineSequence.push([promo, { opacity: [0, 1] }, { duration: 0.25, delay: contentDelay, at: "mega-menu" }], "mega-menu-promo");
      });
      this.contentElement.querySelectorAll(".mega-menu__nav > li").forEach((column) => {
        timelineSequence.push([column.querySelectorAll(":scope > :first-child, :scope li"), { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", delay: stagger(0.025, { start: contentDelay }), at: "mega-menu", duration: 0.2 }]);
      });
    }
    return timeline3(timelineSequence).finished;
  }
  /**
   * When the toggle is hovered we preload the mega-menu images to improve perceived performance
   */
  _preloadImages() {
    Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach((image) => image.setAttribute("loading", "eager"));
  }
};
var MegaMenuPromoCarousel = class extends EffectCarousel2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.nextElementSibling) {
      this.addEventListener("carousel:select", (event) => this._updateControlsColor(event.detail.slide));
    }
    this._updateControlsColor(this.items[this.selectedIndex]);
  }
  _updateControlsColor(slide) {
    const extractFrom = slide.classList.contains("content-over-media") ? slide : slide.firstElementChild;
    this.nextElementSibling.style.setProperty("--text-color", extractFrom.style.getPropertyValue("--text-color"));
  }
};
var NavigationDrawer = class extends Drawer {
  constructor() {
    super();
    const delegate = new Delegate2(this);
    delegate.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this));
    this._isTransitioning = false;
    this.addEventListener("dialog:after-hide", () => {
      this.reinitializeDrawer();
    });
  }
  get openFrom() {
    return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
  }
  // Used for navigation mobile and navigation desktop set to drawer
  switchToPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let panelToHideTransform, panelToShowTransform, panelToHide = linkListIndex !== null ? panels[parseInt(panelIndex) - 1] : panels[parseInt(panelIndex) + 1], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper"), timelineSequence = [];
    if (document.dir === "rtl") {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"];
    } else {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"];
    }
    timelineSequence.push(
      [panelToHide, { transform: panelToHideTransform, opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.3, opacity: { at: "+0.3" }, transform: { at: "+0.3" } }],
      "panelHidden",
      [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"], transform: panelToShowTransform }, { at: "<", transform: { duration: 0.3 } }]
    );
    if (linkListIndex !== null) {
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    timeline3(timelineSequence);
  }
  // Used when mega menu is set to drawer
  showPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let timelineSequence = [], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper");
    if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
      this._isTransitioning = true;
      timelineSequence.push(
        [this, { width: [this.offsetWidth + "px", (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px"] }, { duration: 0.2 }],
        [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }]
      );
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }
    if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
      timelineSequence.push([linkLists[this.previousLinkIndex], { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }]);
    }
    timeline3(timelineSequence).finished.then(() => {
      if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
        linkLists[this.previousLinkIndex].removeAttribute("style");
      }
      if (panelToShow.hasAttribute("open") && this.previousLinkIndex !== linkListIndex) {
        timeline3([this.switchLinkList(linkLists, linkListIndex)]);
      }
      this.previousLinkIndex = linkListIndex;
      panelToShow.setAttribute("open", "");
      this._isTransitioning = false;
    });
  }
  expandPanel(_, panelIndex = null) {
    const panels = this.querySelectorAll(".panel__scroller > ul > li");
    let panelToShow = panels[panelIndex].querySelector(".panel__wrapper_child");
    let expandBtn = panels[panelIndex].querySelector('button[aria-expanded="false"]');
    let closeBtn = panels[panelIndex].querySelector('button[aria-expanded="ture"]');
    if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
      this._isTransitioning = true;
      timeline3([
        [panelToShow, { opacity: [0, 1], maxHeight: ["0", "100%"] }, { at: "<" }],
      ])
      panelToShow.setAttribute("open", "");
      expandBtn.setAttribute("hidden", "");
      closeBtn.removeAttribute("hidden", "");
      this._isTransitioning = false;
    } else {
      if (panelToShow.hasAttribute("open") && !this._isTransitioning) {
        timeline3([
          [panelToShow, { opacity: [1, 0], maxHeight: ["100%", "0"] }, { at: "<" }],
        ])
        panelToShow.removeAttribute("open");
        closeBtn.setAttribute("hidden", "");
        expandBtn.removeAttribute("hidden", "");
        this._isTransitioning = false;
      }
    }
  } 
  switchLinkList(linkLists, linkListIndex) {
    Array.from(linkLists).forEach((item) => {
      item.setAttribute("hidden", "");
    });
    linkLists[linkListIndex].removeAttribute("hidden");
    return [linkLists[linkListIndex].querySelectorAll("li"), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", duration: 0.2, at: "-0.15", delay: stagger(0.025, { start: 0.1 }) }];
  }
  // Set navigation drawer to initial state when drawer closed
  reinitializeDrawer() {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.style.removeProperty("width");
      this.setExpanded();
    } else {
      const firstPanel = this.querySelector(".panel:first-child");
      firstPanel.style.opacity = "1";
      firstPanel.style.visibility = "visible";
      firstPanel.style.transform = "translateX(0%)";
    }
    Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((item) => {
      if (this.hasAttribute("mega-menu")) {
        item.removeAttribute("open");
      }
      item.style.opacity = "0";
      item.style.visibility = "hidden";
      Array.from(item.querySelectorAll(".panel__wrapper")).forEach((list) => list.setAttribute("hidden", ""));
    });
  }
  setExpanded(target) {
    Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
      item.setAttribute("aria-expanded", "false");
    });
    if (target) {
      target.setAttribute("aria-expanded", "true");
    }
  }
  _onPanelButtonClick(event, target) {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.setExpanded(target);
      this.showPanel(...target.getAttribute("data-panel").split("-"));
    } else {
      // this.switchToPanel(...target.getAttribute("data-panel").split("-"));
      this.expandPanel(...target.getAttribute("data-panel").split("-"));
    }
  }
};
if (!window.customElements.get("store-header")) {
  window.customElements.define("store-header", StoreHeader);
}
if (!window.customElements.get("dropdown-disclosure")) {
  window.customElements.define("dropdown-disclosure", DropdownDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-disclosure")) {
  window.customElements.define("mega-menu-disclosure", MegaMenuDisclosure, { extends: "details" });
}
if (!window.customElements.get("mega-menu-promo-carousel")) {
  window.customElements.define("mega-menu-promo-carousel", MegaMenuPromoCarousel);
}
if (!window.customElements.get("navigation-drawer")) {
  window.customElements.define("navigation-drawer", NavigationDrawer);
}

// js/sections/feature-chart.js
import { animate as motionAnimate, scroll } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
var FeatureChart = class extends HTMLElement {
  connectedCallback() {
    this.viewButtonElement = this.querySelector('[data-action="toggle-rows"]');
    this.featureChartTable = this.querySelector(".feature-chart__table");
    this.featureChartRows = Array.from(this.featureChartTable.childNodes);
    this.featureProductRow = this.querySelector(".feature-chart__table-row--product");
    this.featureChartSticky = this.querySelector(".feature-chart__table-row--sticky");
    if (this.viewButtonElement) {
      this.viewButtonElement.addEventListener("click", this._toggleRows.bind(this));
    }
    if (this.featureChartSticky) {
      this.featureChartSticky.style.width = `${this.featureChartTable.scrollWidth}px`;
      this.featureChartTable.addEventListener("scroll", (event) => {
        this.featureChartSticky.style.marginLeft = -1 * event.target.scrollLeft + "px";
      });
      new ResizeObserver((entries) => {
        this.featureChartSticky.style.width = `${entries[0].contentRect.width}px`;
      }).observe(this.featureChartTable);
      const offset = getComputedStyle(this).scrollPaddingTop;
      scroll(({ y }) => {
        if (y.current >= y.targetOffset + this.featureProductRow.clientHeight / 2 && y.progress < 0.85) {
          this.featureChartSticky.classList.add("is-visible");
        } else {
          this.featureChartSticky.classList.remove("is-visible");
        }
      }, {
        target: this.featureChartTable,
        offset: [`${offset} start`, `end ${offset}`]
      });
    }
  }
  _toggleRows() {
    if (this.classList.contains("is-expanded")) {
      this._hideRows();
    } else {
      this._showRows();
    }
  }
  async _showRows() {
    const fromHeight = this.featureChartTable.clientHeight;
    this.featureChartRows.forEach((row) => {
      row.hidden = false;
    });
    this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-less");
    this.classList.add("is-expanded");
    await motionAnimate(this.featureChartTable, { height: [`${fromHeight}px`, `${this.featureChartTable.clientHeight}px`] }).finished;
    this.featureChartTable.style.height = "auto";
  }
  async _hideRows() {
    let fromHeight = this.featureChartTable.clientHeight, toHeight = 0;
    this.featureChartRows.slice(0, parseInt(this.getAttribute("max-rows"))).forEach((row) => {
      toHeight += row.clientHeight;
    });
    this.viewButtonElement.querySelector(".feature-chart__toggle-text").innerText = this.viewButtonElement.getAttribute("data-view-more");
    this.classList.remove("is-expanded");
    await motionAnimate(this.featureChartTable, { height: [`${fromHeight}px`, `${toHeight}px`] }).finished;
    this.featureChartRows.slice(parseInt(this.getAttribute("max-rows"))).forEach((row) => row.hidden = true);
    this.featureChartTable.style.height = "auto";
  }
};
if (!window.customElements.get("feature-chart")) {
  window.customElements.define("feature-chart", FeatureChart);
}

// js/sections/image-banner.js
import { scroll as scroll2, timeline as timeline4, animate as animate2, inView as inView2 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
import { imageLoaded, getHeadingKeyframe } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var ImageBanner = class extends HTMLElement {
  connectedCallback() {
    if (this.parallax && window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      this._setupParallax();
    }
    inView2(this, async () => {
      await imageLoaded(Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")));
      const headings = Array.from(this.querySelectorAll('[reveal-on-scroll="true"]'));
      timeline4([
        [this, { opacity: [0, 1] }, { duration: 0.25 }],
        ...headings.map((heading) => [...getHeadingKeyframe(heading)])
      ]);
    });
  }
  get parallax() {
    return this.hasAttribute("parallax") ? parseFloat(this.getAttribute("parallax")) : false;
  }
  _setupParallax() {
    const media = Array.from(this.querySelectorAll(":scope > :is(img, video, iframe, svg, video-media)")), [scale, translate] = [1 + this.parallax, this.parallax * 100 / (1 + this.parallax)];
    scroll2(
      animate2(media, { transform: [`scale(${scale}) translateY(${translate}%)`, `scale(${scale}) translateY(0)`] }, { easing: "linear" }),
      {
        target: this,
        offset: ["start end", "end start"]
      }
    );
  }
};
if (!window.customElements.get("image-banner")) {
  window.customElements.define("image-banner", ImageBanner);
}

// js/sections/image-link-blocks.js
import { ScrollArea } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var ImageLinkBlocks = class extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    new ScrollArea(this);
    this.addEventListener("control:prev", this._prev);
    this.addEventListener("control:next", this._next);
  }
  _prev() {
    this.scrollBy({ left: (document.dir === "rtl" ? 1 : -1) * this.items[0].clientWidth, behavior: "smooth" });
  }
  _next() {
    this.scrollBy({ left: (document.dir === "rtl" ? -1 : 1) * this.items[0].clientWidth, behavior: "smooth" });
  }
};
if (!window.customElements.get("image-link-blocks")) {
  window.customElements.define("image-link-blocks", ImageLinkBlocks);
}

// js/sections/images-with-text-scrolling.js
import { animate as animate3, timeline as timeline5, inView as inView3 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
import { getHeadingKeyframe as getHeadingKeyframe2, throttle as throttle2 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var ImagesWithTextScrolling = class extends HTMLElement {
  connectedCallback() {
    inView3(this, this._reveal.bind(this));
    if (this.hasAttribute("scrolling-experience")) {
      this._imageToTransitionItems = Array.from(this.querySelectorAll(".images-scrolling-desktop__media-wrapper > :not(:first-child)"));
      this._mainImage = this.querySelector(".images-scrolling-desktop__media-wrapper > :first-child");
      this._contentItems = Array.from(this.querySelectorAll(".images-scrolling__content"));
      if (this._imageToTransitionItems.length > 0) {
        window.addEventListener("scroll", throttle2(this._onScroll.bind(this)));
      }
    }
  }
  _reveal() {
    Array.from(this.querySelectorAll('[reveal-on-scroll="true"]')).forEach((heading) => {
      animate3(...getHeadingKeyframe2(heading));
    });
  }
  _onScroll() {
    const imageRect = this._mainImage.getBoundingClientRect(), imageBottom = imageRect.bottom, imageEffect = this.getAttribute("scrolling-experience");
    for (const [index, contentItem] of this._contentItems.entries()) {
      const contentItemRect = contentItem.getBoundingClientRect(), image = this._imageToTransitionItems[index - 1], content = this._contentItems[index];
      if (contentItemRect.top < imageBottom - imageRect.height * 0.15 && contentItemRect.bottom > imageBottom) {
        if (image && !image.classList.contains("is-visible")) {
          image.classList.add("is-visible");
          if (imageEffect === "fade") {
            timeline5([
              [image, { opacity: [null, 1] }, { duration: 0.2 }],
              [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }]
            ]);
          } else {
            timeline5([
              [image, { opacity: [null, 1], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
              [content, { opacity: [null, 1] }, { duration: 0.45, at: "<" }]
            ]);
          }
        }
        break;
      }
      if (contentItemRect.top > imageBottom - imageRect.height * 0.15) {
        if (image && image.classList.contains("is-visible")) {
          image.classList.remove("is-visible");
          if (imageEffect === "fade") {
            timeline5([
              [image, { opacity: [null, 0] }, { duration: 0.2 }],
              [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }]
            ]);
          } else {
            timeline5([
              [image, { opacity: [null, 1], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] }, { duration: 0.35, easing: [0.99, 0.01, 0.5, 0.94], opacity: { duration: 0 } }],
              [content, { opacity: [null, 0] }, { duration: 0.2, at: "<" }]
            ]);
          }
        }
        break;
      }
    }
  }
};
if (!window.customElements.get("images-with-text-scrolling")) {
  window.customElements.define("images-with-text-scrolling", ImagesWithTextScrolling);
}

// js/sections/impact-text.js
import { animate as animate4, inView as inView4 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
var ImpactText = class extends HTMLElement {
  connectedCallback() {
    if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      return;
    }
    inView4(this, ({ target }) => this._onBecameVisible(target), { margin: "-100px" });
  }
  async _onBecameVisible(target) {
    animate4(target, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 });
    if (this.hasAttribute("count-up")) {
      const itemToSearch = this.childElementCount === 0 ? this : this.firstElementChild, matches = itemToSearch.textContent.trim().match(/\d+(?:[,. ]\d+)*/);
      if (!matches) {
        return;
      }
      itemToSearch.innerHTML = itemToSearch.textContent.replace(/\d+(?:[,. ]\d+)*/, `<span>${matches[0]}</span>`);
      const numberSpan = itemToSearch.querySelector("span");
      numberSpan.style.textAlign = matches[0] === matches["input"] ? null : "end";
      if (!itemToSearch.classList.contains("text-gradient")) {
        numberSpan.style.display = "inline-block";
        numberSpan.style.minWidth = `${numberSpan.clientWidth}px`;
      }
      const toReplace = matches[0].replace(/[,\. ]+/, ""), charactersMatches = [...matches[0].matchAll(/[,\. ]+/g)];
      await animate4((progress) => {
        let formattedString = Math.round(progress * parseInt(toReplace)).toString();
        charactersMatches.forEach((character) => {
          if (formattedString.length >= matches[0].length - character.index) {
            formattedString = formattedString.slice(0, character.index) + character[0] + formattedString.slice(character.index);
          }
        });
        numberSpan.textContent = progress === 1 ? matches[0] : formattedString;
      }, { duration: parseFloat(this.getAttribute("count-up")), easing: [0.16, 1, 0.3, 1] }).finished;
      numberSpan.style.minWidth = null;
    }
  }
};
if (!window.customElements.get("impact-text")) {
  window.customElements.define("impact-text", ImpactText);
}

// js/sections/media-grid.js
import { timeline as timeline6, inView as inView5 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
var MediaGrid = class extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.children);
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      inView5(this, this._onBecameVisible.bind(this));
    }
  }
  _onBecameVisible() {
    const contentElements = this.querySelectorAll(".content-over-media > :not(img, video, iframe, svg, video-media, native-video, external-video)");
    timeline6([
      [this.items, { opacity: 1, transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.3 }],
      [contentElements, { opacity: [0, 1] }, { duration: 0.2, at: "+0.1" }]
    ]);
  }
};
if (!window.customElements.get("media-grid")) {
  window.customElements.define("media-grid", MediaGrid);
}

// js/sections/media-with-text.js
import { animate as animate5, timeline as timeline7, inView as inView6 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
import { imageLoaded as imageLoaded2 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var MediaWithText = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      Array.from(this.querySelectorAll(".media-with-text__item")).forEach((item) => {
        inView6(item, (observer) => this.reveal(observer.target));
      });
    }
  }
  reveal(item) {
    const media = item.querySelector(".media-with-text__media");
    imageLoaded2(media.querySelector("img")).then(() => {
      timeline7([
        [media, { opacity: [0, 1] }, { duration: 0.3 }],
        [media.querySelector("img, video-media"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }]
      ]);
    });
    animate5(item.querySelector(".media-with-text__content > .prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.3 });
  }
};
if (!window.customElements.get("media-with-text")) {
  window.customElements.define("media-with-text", MediaWithText);
}

// js/sections/multiple-images-with-text.js
import { timeline as timeline8, animate as animate6, stagger as stagger2, inView as inView7 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
import { EffectCarousel as EffectCarousel3, imageLoaded as imageLoaded3, getHeadingKeyframe as getHeadingKeyframe3 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var MultipleImagesWithText = class extends HTMLElement {
  constructor() {
    super();
    this._imageCarousel = this.querySelector("multiple-images-with-text-image-list");
    this._contentCarousel = this.querySelector("multiple-images-with-text-content-list");
    this.addEventListener("control:prev", () => {
      this._imageCarousel.previous();
      this._contentCarousel.previous();
    });
    this.addEventListener("control:next", () => {
      this._imageCarousel.next();
      this._contentCarousel.next();
    });
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => {
        if (event.target.hasAttribute("image-id")) {
          this._imageCarousel.select(this._imageCarousel.items.findIndex((item) => item.id === event.target.getAttribute("image-id")));
        }
      });
    }
  }
};
var MultipleImagesWithTextImageList = class extends EffectCarousel3 {
  constructor() {
    super();
    inView7(this, this._reveal.bind(this));
  }
  async _reveal() {
    await imageLoaded3(this.querySelectorAll("img"));
    if (this.getAttribute("layout") === "stacked") {
      timeline8([
        [this.lastElementChild, { transform: "rotate(0deg)" }],
        [this.lastElementChild?.previousElementSibling, { transform: "rotate(2deg)" }, { at: "<" }],
        [this.lastElementChild?.previousElementSibling?.previousElementSibling, { transform: "rotate(-2deg)" }, { at: "<" }]
      ], {
        defaultOptions: { duration: 0.15, easing: [0.26, 0.02, 0.27, 0.97] }
      });
    } else if (this.getAttribute("layout") === "collage") {
      timeline8([
        [this.children, { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.3, delay: stagger2(0.1) }]
      ]);
    } else {
      timeline8([
        [this.children, { opacity: 1, transform: "rotate(var(--image-rotation, 0deg))" }, { duration: 0.3, delay: stagger2(0.1) }]
      ]);
    }
  }
  _transitionTo(fromSlide, toSlide, { direction, animate: animate8 }) {
    if (this.getAttribute("layout") !== "stacked") {
      return;
    }
    const transitionSpeed = 0.2;
    if (direction === "next") {
      const fromSlideTransform = getComputedStyle(fromSlide).getPropertyValue("transform");
      return timeline8([
        [fromSlide, { opacity: 0, transform: "rotate(5deg) translate(40px, 10px)" }, { duration: transitionSpeed }],
        [toSlide, { zIndex: 1 }, { duration: transitionSpeed, zIndex: { easing: "step-start" } }],
        [fromSlide, { opacity: 1, transform: fromSlideTransform, zIndex: -1 }, { duration: transitionSpeed, at: "<", zIndex: { easing: "step-start" } }],
        [toSlide.previousElementSibling, { zIndex: 0 }, { at: "<", easing: "step-start" }]
      ], { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }).finished;
    } else {
      const toSlideTransform = getComputedStyle(toSlide).getPropertyValue("transform");
      return timeline8([
        [toSlide, { opacity: 0, transform: "rotate(-5deg) translate(-40px, -10px)" }, { duration: transitionSpeed }],
        this.items.length >= 3 && [fromSlide.previousElementSibling || this.lastElementChild, { zIndex: -1 }, { easing: "step-start" }],
        [toSlide, { opacity: 1, transform: toSlideTransform, zIndex: 1 }, { duration: transitionSpeed, at: this.items.length >= 3 ? "<" : "+0", zIndex: { easing: "step-start" } }],
        [fromSlide, { zIndex: 0 }, { duration: transitionSpeed, at: "<", zIndex: { easing: "step-start" } }]
      ].filter(Boolean), { defaultOptions: { easing: [0.26, 0.02, 0.27, 0.97] } }).finished;
    }
  }
};
var MultipleImagesWithTextContentList = class extends EffectCarousel3 {
  constructor() {
    super();
    inView7(this, this._reveal.bind(this));
  }
  _reveal() {
    animate6(...getHeadingKeyframe3(this.querySelector('[reveal-on-scroll="true"]')));
  }
  _transitionTo(fromSlide, toSlide, { direction = "next", animate: animate8 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    return timeline8([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"] }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"] }],
      [...getHeadingKeyframe3(toSlide.querySelector('[reveal-on-scroll="true"]'), { at: "<" })]
    ], { duration: animate8 ? parseFloat(this.getAttribute("fade-speed") || 0.5) : 0 }).finished;
  }
};
if (!window.customElements.get("multiple-images-with-text")) {
  window.customElements.define("multiple-images-with-text", MultipleImagesWithText);
}
if (!window.customElements.get("multiple-images-with-text-image-list")) {
  window.customElements.define("multiple-images-with-text-image-list", MultipleImagesWithTextImageList);
}
if (!window.customElements.get("multiple-images-with-text-content-list")) {
  window.customElements.define("multiple-images-with-text-content-list", MultipleImagesWithTextContentList);
}

// js/sections/newsletter-popup.js
import { Drawer as Drawer2 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var NewsletterPopup = class extends Drawer2 {
  connectedCallback() {
    super.connectedCallback();
    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get initialFocus() {
    return false;
  }
  get shouldAppendToBody() {
    return false;
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppearAutomatically() {
    return !(localStorage.getItem("theme:popup-filled") === "true" || this.hasAttribute("only-once") && localStorage.getItem("theme:popup-appeared") === "true");
  }
  _setInitialPosition() {
    this.style.top = null;
    this.style.bottom = "0px";
    this.style.left = document.dir === "ltr" ? null : "0px";
    this.style.right = document.dir === "rtl" ? "auto" : "0px";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:popup-appeared", "true");
    }
  }
};
if (!window.customElements.get("newsletter-popup")) {
  window.customElements.define("newsletter-popup", NewsletterPopup);
}

// js/sections/press.js
import { timeline as timeline9, animate as animate7, inView as inView8 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
import { EffectCarousel as EffectCarousel4 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var reduceMotion2 = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var PressCarousel = class extends EffectCarousel4 {
  constructor() {
    super();
    if (reduceMotion2) {
      inView8(this, this._reveal.bind(this));
    }
  }
  _reveal() {
    animate7(this.selectedSlide.querySelector(".blockquote"), { opacity: 1, transform: ["translateY(15px)", "translateY(0)"] }, { duration: 0.2 });
  }
  async _transitionTo(fromSlide, toSlide, options = {}) {
    await timeline9([
      [fromSlide.querySelectorAll(".press__logo, .press__author"), { opacity: [null, 0] }, { duration: 0.2 }],
      [fromSlide.querySelector(".blockquote"), { opacity: [null, 0], ...reduceMotion2 && { transform: [null, "translateY(-10px)"] } }, { duration: 0.2, at: "<" }]
    ]).finished;
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    await timeline9([
      [toSlide.querySelectorAll(".press__logo, .press__author"), { opacity: [0, 1] }, { duration: 0.2 }],
      [toSlide.querySelector(".blockquote"), { opacity: [0, 1], ...reduceMotion2 && { transform: ["translateY(10px)", "translateY(0px)"] } }, { duration: 0.2, at: "<" }]
    ]).finished;
  }
};
if (!window.customElements.get("press-carousel")) {
  window.customElements.define("press-carousel", PressCarousel);
}

// js/sections/product-recommendations.js
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super();
    this._isLoaded = false;
  }
  connectedCallback() {
    this._loadRecommendations();
  }
  async _loadRecommendations() {
    if (this._isLoaded) {
      return;
    }
    this._isLoaded = true;
    const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${section.id.replace("shopify-section-", "")}&intent=${intent}`, response = await fetch(url, { priority: "low" });
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = tempDiv.querySelector("product-recommendations");
    if (productRecommendationsElement.childElementCount > 0) {
      this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
    } else {
      if (intent === "related") {
        section.remove();
      } else {
        this.remove();
      }
    }
  }
};
if (!window.customElements.get("product-recommendations")) {
  window.customElements.define("product-recommendations", ProductRecommendations);
}

// js/sections/recently-viewed-products.js
import { extractSectionId } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var _isLoaded, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn;
var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _searchQueryString);
    __privateAdd(this, _loadProducts);
    __privateAdd(this, _isLoaded, false);
  }
  connectedCallback() {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(__privateMethod(this, _loadProducts, loadProducts_fn).bind(this), { timeout: 1500 });
    } else {
      __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
    }
  }
};
_isLoaded = new WeakMap();
_searchQueryString = new WeakSet();
searchQueryString_get = function() {
  const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
  if (this.hasAttribute("exclude-id")) {
    items.delete(parseInt(this.getAttribute("exclude-id")));
  }
  return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
};
_loadProducts = new WeakSet();
loadProducts_fn = async function() {
  if (__privateGet(this, _isLoaded)) {
    return;
  }
  __privateSet(this, _isLoaded, true);
  const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _searchQueryString, searchQueryString_get)}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
  if (recentlyViewedProductsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
  } else {
    section.remove();
  }
};
if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

// js/sections/revealed-image-on-scroll.js
import { scroll as scroll3, timeline as timeline10, ScrollOffset, inView as inView9 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
var RevealedImage = class extends HTMLElement {
  connectedCallback() {
    const scrollTracker = this.querySelector(".revealed-image__scroll-tracker"), scroller = this.querySelector(".revealed-image__scroller");
    scrollTracker.style.height = `${scroller.clientHeight}px`;
    new ResizeObserver((entries) => scrollTracker.style.height = `${entries[0].contentRect.height}px`).observe(scroller);
    scroll3(timeline10([
      [this.querySelectorAll(".revealed-image__image-clipper, .revealed-image__content--inside"), { clipPath: ["inset(37% 37% 41% 37%)", "inset(calc(var(--sticky-area-height) / 2) 0)"] }, { easing: "ease-in" }],
      [this.querySelectorAll("img, svg"), { transform: ["translate(-10%, -1.5%) scale(1.4)", "translate(0, 0) scale(1)"] }, { easing: "ease-in", at: "<" }],
      [this.querySelectorAll(".revealed-image__content"), { opacity: [0, 1, 1] }, { offset: [0, 0.25, 1], at: "<" }]
    ]), {
      target: scrollTracker,
      offset: ScrollOffset.All
    });
    inView9(this, () => {
      this.style.visibility = "visible";
      return () => {
        this.style.visibility = "hidden";
      };
    }, { margin: "200px" });
  }
};
if (!window.customElements.get("revealed-image")) {
  window.customElements.define("revealed-image", RevealedImage);
}

// js/sections/shop-the-look.js
var ShopTheLookDots = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    Array.from(this.children).forEach((dots) => {
      document.getElementById(dots.getAttribute("aria-controls")).addEventListener("carousel:change", (event) => this._onDotClicked(event), { signal: this._abortController.signal });
    });
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  _onDotClicked(event) {
    Array.from(this.querySelectorAll(`button:nth-child(${event.detail.index + 1})`)).forEach((button) => button.click());
  }
};
if (!window.customElements.get("shop-the-look-dots")) {
  window.customElements.define("shop-the-look-dots", ShopTheLookDots);
}

// js/sections/slideshow.js
import { animate as motionAnimate2, timeline as timeline11, inView as inView10 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/vendor.min.js?v=20880576495916334881787281486";
import { EffectCarousel as EffectCarousel5, imageLoaded as imageLoaded4, getHeadingKeyframe as getHeadingKeyframe4 } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var Slideshow = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("carousel:select", this._onSlideSelected);
  }
  async _onSlideSelected(event) {
    const slideStyles = getComputedStyle(event.detail.slide);
    this.style.setProperty("--slideshow-controls-background", slideStyles.getPropertyValue("--slideshow-slide-controls-background"));
    this.style.setProperty("--slideshow-controls-color", slideStyles.getPropertyValue("--slideshow-slide-controls-color"));
    if (!this.classList.contains("slideshow--boxed")) {
      return;
    }
    const backgroundElement = this.querySelector(".slideshow__slide-background");
    const background = slideStyles.getPropertyValue("--slideshow-slide-background");
    backgroundElement.style.background = background;
    await motionAnimate2(backgroundElement, { opacity: [0, 1] }, { duration: 0.2 }).finished;
    this.style.setProperty("--slideshow-background", background);
    motionAnimate2(backgroundElement, { opacity: 0 }, { duration: 0 });
  }
};
var SlideshowCarousel = class extends EffectCarousel5 {
  constructor() {
    super();
    inView10(this, this._reveal.bind(this));
    if (this.querySelector(".slideshow__cursor")) {
      this.addEventListener("tap", this._onSlideshowTap);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    if (this._player && this.hasAttribute("autoplay")) {
      this._player.addEventListener("player:start", () => {
        const cursorRing = this.querySelector(".slideshow__cursor-ring circle");
        if (cursorRing) {
          motionAnimate2(cursorRing, { strokeDasharray: [`0px, ${cursorRing.getTotalLength()}px`, `${cursorRing.getTotalLength()}px, ${cursorRing.getTotalLength()}px`] }, {
            duration: parseInt(this.getAttribute("autoplay")),
            easing: "linear"
          });
        }
        const circles = Array.from(this.querySelectorAll(".numbered-dots__item"));
        circles.forEach((item) => {
          const circle = item.querySelector("circle:last-child");
          if (item.getAttribute("aria-current") === "true") {
            motionAnimate2(circle, { strokeDasharray: [`0px, ${circle.getTotalLength()}px`, `${circle.getTotalLength()}px, ${circle.getTotalLength()}px`] }, { duration: parseInt(this.getAttribute("autoplay")), easing: "linear" });
          } else {
            motionAnimate2(circle, { strokeDasharray: `${circle.getTotalLength()}px, ${circle.getTotalLength()}px` }, { duration: 0, easing: "linear" });
          }
        });
      });
    }
  }
  get transitionType() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "fade" : this.getAttribute("transition");
  }
  async _reveal() {
    const selectedSlide = this.selectedSlide;
    await imageLoaded4(selectedSlide.querySelectorAll("img"));
    this.style.opacity = "1";
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    if (!this._reloaded) {
      timeline11([
        [selectedSlide, { zIndex: 1 }, { duration: 0 }],
        // [selectedSlide.querySelectorAll("img"), { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3 }],
        [selectedSlide.querySelectorAll("img"), { opacity: [0, 1] }, { duration: 0.3 }],
        "content",
        [selectedSlide.querySelectorAll('[data-sequence="subheading"], .button'), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
        [...getHeadingKeyframe4(selectedSlide.querySelector('[data-sequence="heading"]'), { duration: 0.3, at: "content" })],
        [selectedSlide.querySelector(".button"), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
        [this.querySelector(".slideshow__controls"), { opacity: [0, 1] }, { duration: 0.3 }]
      ]);
    }
  }
  _onSlideshowTap(event) {
    if (event.target.matches("button, a[href], button :scope, a[href] :scope") || !window.matchMedia("screen and (pointer: fine)").matches) {
      return;
    }
    event.detail.originalEvent.clientX > window.innerWidth / 2 ? this.next() : this.previous();
  }
  /**
   * Perform a simple fade animation. For more complex animations, you should implement your own custom elements
   * that extends the EffectCarousel, and implement your own transition. You should make sure to return a promise
   * that resolves when the animation is finished
   */
  async _transitionTo(fromSlide, toSlide, { direction, animate: animate8 = true } = {}) {
    fromSlide.classList.remove("is-selected");
    toSlide.classList.add("is-selected");
    let timelineControls = null;
    switch (this.transitionType) {
      case "fade":
        timelineControls = this._fade(fromSlide, toSlide, { animate: animate8 });
        break;
      case "fade_with_text":
        timelineControls = this._fadeWithText(fromSlide, toSlide, { animate: animate8 });
        break;
      case "none":
        return true;
    }
    if (!animate8) {
      timelineControls.finish();
    }
    return timelineControls.finished;
  }
  /**
   * Perform a simple fade transition
   */
  _fade(fromSlide, toSlide) {
    return timeline11([
      [fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { duration: 0.3, easing: "ease-in", zIndex: { easing: "step-end" } }],
      [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { duration: 0.3, at: "<", easing: "ease-out", zIndex: { easing: "step-end" } }]
    ]);
  }
  /**
   * Perform a transition with fade images and image transition
   */
  async _fadeWithText(fromSlide, toSlide) {
    motionAnimate2(fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"], zIndex: 0 }, { duration: 0.2, easing: "ease-in", zIndex: { easing: "step-end" } });
    await imageLoaded4(toSlide.querySelectorAll("img"));
    motionAnimate2(toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"], zIndex: 1 }, { duration: 0.2, delay: 0.2, zIndex: { easing: "step-end" } });
    return timeline11([
      // [toSlide.querySelectorAll("img"), { opacity: [0, 1], transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, easing: "ease-out" }],
      [toSlide.querySelectorAll("img"), { opacity: [0, 1] }, { duration: 0.3, easing: "ease-out" }],
      "content",
      [toSlide.querySelectorAll('[data-sequence="subheading"], .button'), { opacity: [0, 1] }, { duration: 0.3, at: "content" }],
      [...getHeadingKeyframe4(toSlide.querySelector('[data-sequence="heading"]'), { duration: 0.3, at: "content" })]
    ]);
  }
};
if (!window.customElements.get("x-slideshow")) {
  window.customElements.define("x-slideshow", Slideshow);
}
if (!window.customElements.get("slideshow-carousel")) {
  window.customElements.define("slideshow-carousel", SlideshowCarousel);
}


/**
 * Collin Lee
 * Add Scroll Blur Animation
 * 2025-04-09
 */
import { CollinPagination } from "//www.yoshinopower.co.jp/cdn/shop/t/27/assets/theme.js?v=2629329962499794781787281511";
var __scroll__animationMap = new Map();
var ScrollBlurElement = class extends HTMLElement {
  _setAnimationMap() {
    const containerRect = this.getBoundingClientRect();
    const scrollY = window.scrollY;
    const scrollStart = containerRect.top + scrollY;
    const scrollEnd = containerRect.bottom + scrollY - window.innerHeight;
    const scroll_2_3 = scrollEnd * 2 / 3;

    const scrollBg = this.querySelector('.scroll-blur-background');
    const figure = this.querySelector('.scroll-blur-picture');
    const _this = this;
    __scroll__animationMap.set(scrollBg, {
    '--filter-blur': function(x) {
      return `${_this._createAnimation(scrollStart, scroll_2_3, 0, 4)(x)}px`;
    }});
    __scroll__animationMap.set(figure, {
    '--translate-y': function(x) {
      return `${_this._createAnimation(scroll_2_3, scrollEnd - 200, 16, 1)(x)}px`;
    },
    '--opacity': function(x) {
      return `${_this._createAnimation(scroll_2_3, scrollEnd - 200, 0, 1)(x)}`;
    }});
  }
  disconnectedCallback() {
    __scroll__animationMap.delete(this);
  }
  _createAnimation(scrollStart, scrollEnd, startValue, endValue) {
    return function(x) {
      if (x < scrollStart) 
        return startValue;
      if (x > scrollEnd)
        return endValue;
      const progress = (x - scrollStart) / (scrollEnd - scrollStart);
      return startValue + (endValue - startValue) * progress;
    }
  }
};
if (!window.customElements.get("scroll-blur")) {
  window.customElements.define("scroll-blur", ScrollBlurElement);
}

/**
 * Collin Lee
 * Add Scroll to top button
 * 2024-10-21
 */
document.addEventListener('DOMContentLoaded', function() {
  const fixedBtn = document.getElementById('fixedBtnMobi');
  const backToTopBtn = document.getElementById('backToTopBtn');
  
  window.addEventListener('scroll', function() {
      if (window.scrollY > 100) {
          fixedBtn.style.display = 'flex';
      } else {
          fixedBtn.style.display = 'none';
      }
  });

  backToTopBtn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', function() {
      if (window.scrollY === 0) {
          fixedBtn.style.display = 'none';
      }

      const scrollY = window.scrollY; // 如果要计算某个容器内的滚动量，请使用 ele.scrollTop
      for (const [dom, animations] of __scroll__animationMap) {
        for (const prop in animations) {
          // dom.style[prop] = animations[prop](scrollY);
          dom.style.setProperty(prop, animations[prop](scrollY));
          // panel.style.setProperty(prop, animations[prop](scrollY));
        }
      }
  });

});

// 将滚动位置与每一个dom 的 css 属性做映射
document.addEventListener("DOMContentLoaded", function() {
  // 滚动动画特效
  function addAnimatedClass(element) {
    if (element.classList.contains('animate__el')) {
      const animation = element.dataset.animation;
      element.classList.add('animate__animated', `animate__${animation}`);
    }
    element.querySelectorAll('.animate__el').forEach(child => {
      const child_animation = child.dataset.animation;
      child.classList.add('animate__animated', `animate__${child_animation}`);
    });
  }

  const animateElements = document.querySelectorAll('[data-animate="true"]');
  const observers = [0.1, 0.3, 0.5].reduce((acc, curr) => {
     const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // add animate class
          addAnimatedClass(entry.target);
          observer.unobserve(entry.target); // Stop observing once the element is visible
        }
      })
    }, {threshold: curr})
    acc[''+curr] = observer;
    return acc;
  }, {});

  animateElements && animateElements.forEach(an => {
    const threshold = an.dataset.threshold || 0.5;
    observers[threshold].observe(an);
  });

  // 页面加载完成后，添加动画类
  const animateElOnLoaded = document.querySelectorAll('[data-animate="on-loaded"]');
  animateElOnLoaded && animateElOnLoaded.forEach(el => addAnimatedClass(el));

  // 加载滚动动画效果
  if (window.location.pathname == '/pages/b1200detail') {

    // 固定b1200标题
    const header = document.querySelector('header');
    const headerBar = document.querySelector('#b1200-title-sticky');
    const headerHeight = header.offsetHeight;
    // Function to update header position based on scroll
    function updateHeaderPosition() {
      if (window.scrollY >= headerHeight) {
        headerBar.classList.add('fixed');
      } else {
        headerBar.classList.remove('fixed');
      }
    }

    // Add scroll event listener
    window.addEventListener('scroll', updateHeaderPosition);
    // Update header position on page load
    updateHeaderPosition();

    // if (document.getElementsByTagName('scroll-blur')[0]) {
    //   document.getElementsByTagName('scroll-blur')[0]._setAnimationMap();
    // }

    lax.init();
    // Add a driver that we use to control our animations
    lax.addDriver('scrollY', function () {
      return window.scrollY
    });

    lax.addElements('.b1200-banner-2-title p', {
      scrollY: {
        animation: [
          ['elInY-(screenHeight-elHeight)/2', 'elInY', 'elOutY+screenHeight/2'],
          [-1, 1, 0],
          {
            easing: 'easeInOutQuart',
            cssFn: (value) => {
              return value > 0 ? `fadeInUp .8s linear 1 alternate forwards` : 'fadeOut 0s forwards';
            }
          }
        ]
      }
    });

    lax.addElements('.b1200-battery-2-description-card', {
      scrollY: {
        opacity: [
          ["elInY-(900-146-elHeight)", "elCenterY-(900-146-elHeight)", "elOutY-(900-146-elHeight)"],
          {
            700: [1, 1, 1],
            2100: [0, 1, 1],
          },
        ],
        translateY: [
          ["elInY-(900-146-elHeight)", "elCenterY-(900-146-elHeight)", "elOutY-(900-146-elHeight)"],
          {
            700: [0, 0, 0],
            2100: ['0-elHeight/2', 0, '0-elHeight/4'],
          },
          
        ],
        translateX: [
          ["elInY-(900-146-elHeight)", "elCenterY-(900-146-elHeight)", "elOutY-(900-146-elHeight)"],
          {
            700: [0, 0, 0],
            2100: ['0-elWidth', '0-elWidth', '0-elWidth'],
          },
          
        ],
      }
    });

    lax.addElements('.b1200-circuit-board-title p', {
      scrollY: {
        animation: [
          ['elInY-(screenHeight-elHeight)/2', 'elInY', 'elOutY+screenHeight/2'],
          [-1, 1, 0],
          {
            easing: 'easeInOutQuart',
            cssFn: (value) => {
              return value > 0 ? `fadeInUp .8s linear 1 alternate forwards` : 'fadeOut 0s forwards';
            }
          }
        ]
      }
    });

    // Add animation bindings to elements
    lax.addElements('.lax-circuit-float-card', {
      scrollY: {
        translateX: [
          ["elCenterY+screenHeight/4", "elCenterY+screenHeight/2"],
          ['screenWidth', 0,],
        ],
        opacity: [
          ["elCenterY+screenHeight/4", "elCenterY+screenHeight/2"],
          [0.5, 1],
        ]
      }
    });

    lax.addElements('.b1200-figure-background', {
      scrollY: {
        scale: [
          ["elInY", "elInY+200"],
          {
            700: [1, 1],
            2100: [0.6, 1],
          }
        ]
      }
    });
    
    lax.addElements('.b1200-figure-picture-scroll', {
      scrollY: {
        opacity: [
          ["elInY+200", "elCenterY"],
          {
            700: [1, 1],
            2100: [0, 1],
          }
        ],
        translateY: [
          ["elInY+200", "elCenterY"],
          {
            700: [0, 0],
            2100: [40, 0],
          }
        ]
      }
    });

    lax.addElements('.b1200-figure-description-scroll h2', {
      scrollY: {
        opacity: [
          ["elInY+200", "elCenterY+140"],
          {
            700: [1, 1],
            2100: [0, 1],
          }
        ],
        translateY: [
          ["elInY+200", "elCenterY+140"],
          {
            700: [0, 0],
            2100: ['elHeight', 0],
          }
        ]
      }
    });
    
    lax.addElements('.b1200-figure-description-scroll p', {
      scrollY: {
        opacity: [
          ["elCenterY+150", "elCenterY+160"],
          {
            700: [1, 1],
            2100: [0, 1],
          }
        ],
        translateY: [
          ["elCenterY+150", "elCenterY+160"],
          {
            700: [0, 0],
            2100: ['elHeight', 0],
          }
        ]
      }
    });
    
    
  }

  // 生成FAQ
  if (window.__yoshino_faq_json) {
    const faqCategories = [];
    const faqCategoriesMobi = [];
    const faqMobi = [];
    let faq_index = 1;
    for (const [category, questions] of Object.entries(window.__yoshino_faq_json)) {
      faqCategories.push(`
        <div class="faq-category">
          <div class="faq-category-header">
            <span>${category}</span>
            <span class="toggle-icon">
              <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.27783 15.1421L8.31036 8.07102L1.27783 0.999955" stroke="black" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </span>
          </div>
          <div class="faq-questions">
            ${questions.map(question => `
              <div class="faq-question-item" 
                data-question="${question.question}"
                data-answer="${question.answer}">
                <div class="faq-question-item-content">
                  ${question.question}
                </div>
              </div>`).join('')}
          </div>
        </div>`);
      faqCategoriesMobi.push(`
        <div class="faq-category-mobi">
          <div class="faq-category-header-mobi" data-id="${faq_index}">
            <span>${category}</span>
          </div>
        </div>`);
      faqMobi.push(`
        <div class="faq-questions-mobi md:hidden" data-id="${faq_index}">
          ${questions.map(question => `
            <div class="faq-question-item-mobi" data-question="${question.question}" data-answer="${question.answer}">
                <div class="faq-question-item-content-mobi">
                  <span>${question.question}</span>
                </div>
            </div>`).join('')}
        </div>`);
      faq_index++;
    }
    document.querySelector('.faq-categories').innerHTML = faqCategories.join('');
    document.querySelector('.faq-categories-mobi').innerHTML = faqCategoriesMobi.join('');
    document.querySelector('.faq-new-container').innerHTML = document.querySelector('.faq-new-container').innerHTML.replace('#questions#', faqMobi.join(''));
  }
  // 展开/折叠分类
  if ((window.location.pathname == '/pages/about' && window.location.search == '?view=faq') || window.location.pathname == '/pages/faq') {
    const categoryHeaders = document.querySelectorAll('.faq-category-header');
    if (!categoryHeaders) return;
    categoryHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const category = this.parentElement;
        const questions = category.querySelector('.faq-questions');
        const toggleIcon = this.querySelector('.toggle-icon');
        const isExpanded = questions.style.height && questions.style.height !== '0px';
        
        // 关闭所有其他分类
        document.querySelectorAll('.faq-questions').forEach(el => {
          if (el !== questions) {
            el.style.height = '0px';
            el.style.padding = '0';
            el.previousElementSibling.querySelector('.toggle-icon').style.transform = 'rotate(0deg)';
          }
        });
        
        // 切换当前分类
        if (isExpanded) {
          questions.style.height = '0px';
          questions.style.padding = '0';
          toggleIcon.style.transform = 'rotate(0deg)';
        } else {
          questions.style.height = questions.scrollHeight + 'px';
          questions.style.padding = '';
          toggleIcon.style.transform = 'rotate(90deg)';
        }
      });
      header.parentElement.querySelector('.faq-questions').style.height = '0px';
      header.parentElement.querySelector('.faq-questions').style.padding = '0';
    });

    // 移动端的点击
    const categoryHeadersMobi = document.querySelectorAll('.faq-category-header-mobi');
    categoryHeadersMobi.forEach(header => { 
      header.addEventListener('click', function() {
        document.querySelectorAll('.faq-category-mobi').forEach(panel => {
          panel.classList.remove('active');
        })
        const header = this.parentElement;
        header.classList.add('active');
        const categoryId = this.getAttribute('data-id');

        // 如果详情页是打开则隐藏
        const questionDetail = document.querySelector('.faq-question-detail-mobi.active');
        if (questionDetail) {
          questionDetail.classList.remove('active');
          questionDetail.style.display = 'none';
          // 并且把对应的问题列表动画属性清空
          const activeQuestions = document.querySelector('.faq-questions-mobi.active');
          activeQuestions.style.transform = '';
          activeQuestions.style.display = '';
        }
        // 更新下方问题列表
        document.querySelectorAll('.faq-questions-mobi').forEach(panel => {
          panel.classList.remove('active');
        });
        const choseMobi = document.querySelector('.faq-questions-mobi[data-id="' + categoryId + '"]');
        choseMobi.classList.add('active');
      });
    });
    
    // 点击问题显示详情
    const questionItems = document.querySelectorAll('.faq-question-item');
    const detailInner = document.querySelector('.faq-detail-inner');
    questionItems.forEach(item => {
      item.addEventListener('click', function() {
        // 移除所有active类
        questionItems.forEach(el => el.classList.remove('active'));
        
        // 添加active类到当前项
        this.classList.add('active');
        
        // 获取问题和答案数据
        const question = this.getAttribute('data-question');
        const answer = this.getAttribute('data-answer');
        
        // 更新详情区域
        // document.querySelector('.faq-detail-question').textContent = question;
        // document.querySelector('.faq-detail-answer').innerHTML = answer;
        // document.querySelector('.faq-detail-empty').style.display = 'none';
        // document.querySelector('.faq-detail').style.display = 'block';
        // 开始切换动画
        if (detailInner) {
          detailInner.classList.remove('active');
          // 第一阶段：当前内容向右滑出
          detailInner.classList.add('slide-out');
          
          // 等待动画完成
          setTimeout(() => {
            // 更新内容
            const questionEl = document.querySelector('.faq-detail-question');
            const answerEl = document.querySelector('.faq-detail-answer');
            
            if (questionEl) questionEl.textContent = question;
            if (answerEl) answerEl.innerHTML = answer;
            
            // 第二阶段：新内容从左侧滑入
            detailInner.classList.remove('slide-out');
            detailInner.classList.add('slide-in');
            
            // 强制重绘
            void detailInner.offsetWidth;
            
            // 第三阶段：滑动到中心位置
            detailInner.classList.remove('slide-in');
            detailInner.classList.add('active');
            
            // 显示详情区域
            document.querySelector('.faq-detail-empty').style.display = 'none';
            document.querySelector('.faq-detail').style.display = 'block';
          }, 400); // 与CSS过渡时间匹配
        }
      });
    });

    // 点击问题显示详情(移动端)
    const questionItemsMobi = document.querySelectorAll('.faq-question-item-mobi');
    const detailInnerMobi = document.querySelector('.faq-question-detail-mobi');
    questionItemsMobi.forEach(item => {
      item.addEventListener('click', function() {
        // 移除所有active类
        questionItems.forEach(el => el.classList.remove('active'));
        
        // 添加active类到当前项
        this.classList.add('active');
        
        // 获取问题和答案数据
        const question = this.getAttribute('data-question');
        const answer = this.getAttribute('data-answer');
        
        // 更新详情区域
        // document.querySelector('.faq-detail-question').textContent = question;
        // document.querySelector('.faq-detail-answer').innerHTML = answer;
        // document.querySelector('.faq-detail-empty').style.display = 'none';
        // document.querySelector('.faq-detail').style.display = 'block';
        // 开始切换动画
        if (detailInnerMobi) {
          // 第一阶段：当前内容向右滑出
          const questionItem = document.querySelector('.faq-questions-mobi.active');
          questionItem.style.transform = 'translateX(calc(-1*100vw))';

          // 更新内容
          const questionEl = document.querySelector('.faq-detail-question-mobi');
          const answerEl = document.querySelector('.faq-detail-answer-mobi');
          
          if (questionEl) questionEl.textContent = question;
          if (answerEl) answerEl.innerHTML = answer;
          
          // 等待动画完成
          setTimeout(() => {
            questionItem.style.display = 'none';

            // 第二阶段：新内容从左侧滑入
            detailInnerMobi.style.display = 'block';
            detailInnerMobi.classList.add('active');
          }, 500); // 与CSS过渡时间匹配
        }
      });
    });

    // 从问题详情点击回问题列表
    const questionDetail = document.querySelector('.faq-detail-answer-back-btn-mobi');
    questionDetail.addEventListener('click', function() { 
      const fqDetail = this.parentElement;
      fqDetail.classList.remove('active');

      setTimeout(() => {
        fqDetail.style.display = 'none';
        const questionItem = document.querySelector('.faq-questions-mobi.active');
        questionItem.style.display = '';
        questionItem.style.transform = 'translateX(0)'
      }, 500);
    });


    const firstCategory = document.querySelector('.faq-category:nth-of-type(1)');
    if (firstCategory) {
      const firstQuestions = firstCategory.querySelector('.faq-questions');
      const firstToggleIcon = firstCategory.querySelector('.toggle-icon');
      firstQuestions.style.height = firstQuestions.scrollHeight + 'px';
      firstQuestions.style.padding = '';
      firstToggleIcon.style.transform = 'rotate(90deg)';
      
      // 默认选中第一个问题
      const firstQuestion = firstCategory.querySelector('.faq-question-item');
      if (firstQuestion) {
        // 直接显示，不播放动画
        firstQuestion.classList.add('active');
        
        const question = firstQuestion.getAttribute('data-question');
        const answer = firstQuestion.getAttribute('data-answer');
        
        document.querySelector('.faq-detail-question').textContent = question;
        document.querySelector('.faq-detail-answer').innerHTML = answer;
        document.querySelector('.faq-detail-empty').style.display = 'none';
        document.querySelector('.faq-detail').style.display = 'block';
      }
    }

    // 移动端默认选中第一个
    const firstCategoryMobi = document.querySelector('.faq-category-header-mobi[data-id="1"]');
    if (firstCategoryMobi) {
      firstCategoryMobi.click();
    }

    // 搜索相关变量
    let searchTimer;
    const searchInput = document.querySelector('.faq-search-input');
    const filterButtons = document.querySelectorAll('.faq-filter-btn');
    const searchResultsInfo = document.querySelector('.faq-search-results');
    let activeFilters = [];
    
    // 初始化所有FAQ数据
    const allFaqItems = Array.from(document.querySelectorAll('.faq-question-item'));
    const allCategories = Array.from(document.querySelectorAll('.faq-category'));
    
    // 切换筛选按钮状态
    filterButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        this.classList.toggle('active');
        updateActiveFilters();
        this.classList.remove('active');
        performSearch();
      });
    });
    
    // 更新激活的筛选条件
    function updateActiveFilters() {
      activeFilters = Array.from(document.querySelectorAll('.faq-filter-btn.active'))
        .map(btn => btn.dataset.filter);
    }
    
    // 执行搜索
    function performSearch() {
      if (activeFilters.length > 0) {
        searchInput.value = activeFilters.join('').toLowerCase();
        activeFilters = [];
      }
      const searchTerm = searchInput.value;
      // 如果没有搜索词且没有激活的筛选条件，显示所有
      // if (!searchTerm && activeFilters.length === 0) {
      //   allFaqItems.forEach(item => item.style.display = '');
      //   allCategories.forEach(category => category.style.display = '');
        // searchResultsInfo.textContent = `显示所有 ${allFaqItems.length} 个问题`;
        // return;
      // }
      
      let visibleCount = 0;
      
      // 过滤FAQ项
      const filteredItems = allFaqItems.filter(item => {
        const question = item.textContent.toLowerCase();
        
        // 检查搜索词
        const matchesSearch = !searchTerm || 
          question.includes(searchTerm) || 
          item.dataset.answer.toLowerCase().includes(searchTerm);
        
        return matchesSearch;
      });
      
      // 显示匹配的FAQ项
      const listItems = filteredItems.map((item, index) => {
        visibleCount++;
        // 高亮搜索关键词
        if (searchTerm) {
          const question = item.textContent;
          const answer = item.dataset.answer;
          const regex = new RegExp(searchTerm, 'gi');
          
          // 高亮问题
          const highlightedQuestion = question.replace(
            regex, 
            match => `<span class="highlight">${match}</span>`
          );
          // 高亮答案
          const highlightedAnswer = answer.replace(
            regex, 
            match => `<span class="highlight">${match}</span>`
          );
          const innerHTML = `
            <div class="faq-new-search-results-item">
              <div class="faq-new-search-results-item-question">
                <span>${highlightedQuestion}</span>
                <span class="toggle-icon">
                  <svg class="md:block hidden" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.27783 15.1421L8.31036 8.07102L1.27783 0.999955" stroke="black" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <svg class="md:hidden" width="0.6rem" height="0.6rem" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.27783 15.1421L8.31036 8.07102L1.27783 0.999955" stroke="black" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </span>
              </div>
              <div class="faq-new-search-results-item-answer" style="max-height: 0;">
                ${highlightedAnswer}
              </div>
            </div>
          `;
          
          return innerHTML;
        }
      });
      
      // 更新搜索结果的信息
      document.querySelector('.faq-new-search-text-tips').textContent = searchInput.value;
      document.querySelector('.faq-new-search-results-count').textContent = visibleCount > 0 ? `${visibleCount}件ヒット` : 'ヒットなし';
      document.querySelector('.faq-new-search-pagination-container').innerHTML = '';
      // 更新搜索结果列表
      document.querySelector('.faq-new-search-results-list').innerHTML = listItems.join('');
      
      const section1 = document.querySelector('.faq-new-container');
      const section2 = document.querySelector('.faq-new-search-results');

      section1.style.display = 'none';
      section2.style.display = 'block';
      
      if (visibleCount > 0) {
        document.querySelector('.faq-new-search-nothing').style.display = 'none';
        const pageSize = document.querySelector('.faq-new-search-pagination-container').getAttribute('data-page-size') || 8;
        new CollinPagination('.faq-new-search-pagination-container', '.faq-new-search-results-list',
          1, pageSize, {
            className: 'faq-new-custom-pagination',
            activeClassName: 'faq-new-custom-pagination-current',
            prevText: `<svg class="md:block hidden" width="9" height="16" viewBox="0 0 9 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 8V9H2V8V7H1V8Z" fill="#555555"/>
            </svg>
            <svg class="md:hidden" width="0.6rem" height="0.6rem" viewBox="0 0 9 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM1 8V9H2V8V7H1V8Z" fill="#555555"/>
            </svg>`,
            nextText: `<svg class="md:block hidden" width="9" height="16" viewBox="0 0 9 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289L2.34315 0.928932C1.95262 0.538408 1.31946 0.538408 0.928932 0.928932C0.538408 1.31946 0.538408 1.95262 0.928932 2.34315L6.58579 8L0.928932 13.6569C0.538408 14.0474 0.538408 14.6805 0.928932 15.0711C1.31946 15.4616 1.95262 15.4616 2.34315 15.0711L8.70711 8.70711ZM7 8V9H8V8V7H7V8Z" fill="#555555"/>
            </svg>
            <svg class="md:hidden" width="0.6rem" height="0.6rem" viewBox="0 0 9 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.70711 8.70711C9.09763 8.31658 9.09763 7.68342 8.70711 7.29289L2.34315 0.928932C1.95262 0.538408 1.31946 0.538408 0.928932 0.928932C0.538408 1.31946 0.538408 1.95262 0.928932 2.34315L6.58579 8L0.928932 13.6569C0.538408 14.0474 0.538408 14.6805 0.928932 15.0711C1.31946 15.4616 1.95262 15.4616 2.34315 15.0711L8.70711 8.70711ZM7 8V9H8V8V7H7V8Z" fill="#555555"/>
            </svg>`,
            ellipsisText: '...',
            // onChange: () => {
            //   const q = document.querySelector('.faq-new-search-results-item:not([style*="display: none"])');
            //   q  && q.querySelector('.faq-new-search-results-item-question').click();
            // },
          }
        );
      } else {
        // 没有找到匹配的信息
        document.querySelector('.faq-new-search-nothing').style.display = '';
      }

      // 展开/折叠分类
      const searchresultsHeaders = document.querySelectorAll('.faq-new-search-results-item-question');
      searchresultsHeaders.forEach((result, index) => {
        result.addEventListener('click', function() {
          const item = this.parentElement;
          const answer = item.querySelector('.faq-new-search-results-item-answer');
          const toggleIcon = this.querySelector('.toggle-icon');
          const isExpanded = answer.style.maxHeight && answer.style.maxHeight !== '0px';
          
          // 关闭所有其他答案
          document.querySelectorAll('.faq-new-search-results-item-answer').forEach(el => {
            if (el !== answer) {
              el.style.maxHeight = '0px';
              el.previousElementSibling.querySelector('.toggle-icon').style.transform = 'rotate(0deg)';
            }
          });
          
          // 切换当前分类
          if (isExpanded) {
            answer.style.maxHeight = '0px';
            toggleIcon.style.transform = 'rotate(0deg)';
          } else {
            answer.style.maxHeight = answer.scrollHeight + 'px';
            toggleIcon.style.transform = 'rotate(90deg)';
          }
        });
        if (index > 0)
          result.parentElement.querySelector('.faq-new-search-results-item-answer').style.maxHeight = '0px';
        });
    }
  
    // 监听搜索输入
    searchInput.addEventListener('keypress', function(event) {
      if (event.key == 'Enter') 
        performSearch();
    });

    // 回到问题列表按钮
    document.querySelector('.faq-new-search-back').addEventListener('click', function() {
      const section1 = document.querySelector('.faq-new-container');
      const section2 = document.querySelector('.faq-new-search-results');

      section1.style.display = 'grid';
      section2.style.display = 'none';
    });
  }
 

});

// 获取class为dropdown-menu-collection的元素下的所有li
const menuItems = document.querySelectorAll('.dropdown-menu-collection li');
menuItems.forEach(item => {
    item.addEventListener('mouseover', function(event) {
        document.querySelectorAll('.dropdown-menu-collection li').forEach(item => item.removeAttribute('on'));
        const el_li = event.target.closest('li');
        // 添加鼠标移入效果
        el_li.setAttribute('on', 'hover');
        // 从触发事件的li里取出属性data-menu-title的值
        const title = el_li.getAttribute('data-menu-title');
        if (!title) {
          return;
        }

        // 找到class为dropdown-menu-thumbs下的所有子div
        const thumbsDivs = document.querySelectorAll('.dropdown-menu-thumbs > div');
        
        // 将这些div的class设为“display-none gap-20”
        thumbsDivs.forEach(div => {
            div.className = 'display-none gap-20';
        });

        // 找到属性data-menu-display-products值为title的div
        const targetDiv = document.querySelector(`.dropdown-menu-thumbs > div[data-menu-display-products="${title}"]`);
        
        // 将该div的class设为“display-flex gap-20”
        if (targetDiv) {
            targetDiv.className = 'display-flex gap-20';
        }
    });
}); 


// 添加下拉菜单遮罩
document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('details[is="dropdown-disclosure"]');
  let timer = null;
  menuItems.forEach(item => {
    item.addEventListener('mouseover', function() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      } else {
        document.querySelector('.fixed-overlay').style.display = 'block';
      }
    });

    item.addEventListener('mouseout', function() {
      timer = setTimeout(() => {
        document.querySelector('.fixed-overlay').style.display = 'none';
        timer = null;
      }, 250);
    });
  });

  window.addEventListener('scroll', function() {
    const scrollPosition = window.scrollY;
    const headerHeight = document.querySelector("header").clientHeight;

    if (scrollPosition > headerHeight) {
      document.querySelector('.fixed-overlay').style.top = -1 * headerHeight;
    } else {
      document.querySelector('.fixed-overlay').style.top = 0;
    }
  });
});
